<template>
  <v-card
    color="white"
    class="elevation-3 bg-dot-pattern"
    light
  >
    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>
          <span class="red--text text--darken-2">Joseph</span> DeWayne <span class="blue--text text--darken-4">Jordan</span>
        </h1>
        <span class="grey--text text--darken-3 font-weight-medium">
          Head of Support | Customer Success & Technical Support Leader | Veteran
        </span>
      </div>

      <sidebar-section :options="sections.info" />
      <sidebar-section :options="sections.leadership" />
      
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{item}">
          <v-chip class="ma-1 font-weight-bold" color="#e3f2fd" text-color="#0d47a1">
            <v-avatar left>
              <v-icon color="red darken-2" small>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>

      <sidebar-section :options="sections.bestQualities">
        <template v-slot:item="{item}">
          <v-chip class="ma-1 font-weight-bold" color="#e3f2fd" text-color="#0d47a1">
            <v-avatar left>
              <v-icon color="red darken-2" small>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>

      <sidebar-section :options="sections.socials" />
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'CONTACT & CONTEXT',
          items: [
            {
              name: 'Resume / CV',
              icon: 'mdi-file-document-box', 
              text: 'Download PDF',
              link: '/resume.pdf', 
            },
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'joseph.d.jordan321@gmail.com',
              link: 'mailto:joseph.d.jordan321@gmail.com',
            },
            {
              name: 'Deacon & Web Administrator',
              icon: 'mdi-church',
              text: 'Calder Baptist Church',
              link: 'https://www.calderbaptist.org',
            },
            {
              name: 'IDEMIA Public Security',
              icon: 'mdi-briefcase',
              text: 'Customer Success Manager',
              link: 'https://www.idemia.com/business/idemia-public-security',
            },
            {
              name: 'LinkedIn',
              icon: 'mdi-linkedin-box',
              text: 'Connect on LinkedIn',
              link: 'https://linkedin.com/in/josephdjordan1',
            },
            {
              name: 'Base of Operations',
              icon: 'mdi-map-marker',
              text: 'Texas',
            },
          ],
        },
        hobbies: {
          title: 'PASSIONS',
          items: [
            { icon: 'mdi-cards-playing-outline', text: 'Magic: The Gathering' },
            { icon: 'mdi-raspberry-pi', text: 'Home Lab & IoT' },
            { icon: 'mdi-car-turbocharger', text: 'Automotive Enthusiast' },
            { icon: 'mdi-music', text: 'Music' },
            { icon: 'mdi-earth', text: 'Travel' },
          ],
        },
        leadership: {
          title: 'LEADERSHIP',
          items: [
            { icon: 'mdi-account-tie', text : 'Head of Customer Support - FEB 2025 to DEC 2025' }, 
            { icon: 'mdi-account-tie', text : 'Senior Support Team Leader - 2022 to 2025' },
            { icon: 'mdi-account-tie', text : 'Senior Systems and Applications Programmer - 2017 to 2018' },
            { icon: 'mdi-castle', text : 'Vice-President of Sigma Phi Delta - Texas Alumni Chapter - 2017 to 2023' },
            { icon: 'mdi-castle', text : 'President of Sigma Phi Delta - Beta Gamma Chapter - 2015 to 2016' },
            { icon: 'mdi-flag', text : 'Staff Sergeant - United States Army - 2006 to 2013' },
            { icon: 'mdi-flag', text : 'Sergeant - United States Army - 2002 to 2006' },
          ],
        },
        bestQualities: {
          title: 'CORE COMPETENCIES',
          items: [
            { icon: 'mdi-account-group', text: 'Global Team Building' },
            { icon: 'mdi-chess-knight', text: 'Strategic Planning' },
            { icon: 'mdi-robot', text: 'Workflow Automation' },
            { icon: 'mdi-brain', text: 'Emotional Intelligence' },
            { icon: 'mdi-teach', text: 'Mentorship & Training' },
            { icon: 'mdi-shield-check', text: 'Resilience & Reliability' },
          ],
        },
      },
    }
  },
}
</script>

<style scoped>
/* Removed the dark background style to inherit the white v-card color */
.bg-dot-pattern {
  background-color: #ffffff !important;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='3' cy='3' r='1.5' fill='%231565c0' fill-opacity='0.15'/%3E%3C/svg%3E") !important;
  background-repeat: repeat !important; 
}
</style>